<p-floatLabel>
  <p-multiSelect
    [options]="options"
    [(ngModel)]="selectedValues"
    optionLabel="name"
    placeholder="Select"
    optionValue="name"
    [showClear]="false"
    [styleClass]="type ? 'quarter-dropdown' : 'gd-multi-select'"
    [filter]="false"
    (onChange)="onMultiSelectChange($event)"
    (onPanelShow)="showPanel()"
    (onPanelHide)="hidePanel()"
    [inputId]="label"
  >
    <ng-template pTemplate="header">
      <div class="custom-header" (click)="toggleAll()">
        <!-- <input
          type="checkbox"
          (click)="$event.stopPropagation(); toggleAll()"
          [(ngModel)]="isAllChecked"
          [class.is-checked]="isAllChecked"
        /> -->
        <p-checkbox
          [(ngModel)]="isAllChecked"
          styleClass="toggle-all-checkbox"
          [binary]="true"
          inputId="binary"
          (click)="$event.stopPropagation(); toggleAll()"
        />
        <span class="all-text">All</span>
      </div>
    </ng-template>
    <ng-template let-value pTemplate="selectedItems">
      <div class="multi-select-value-container">
        <!-- <span class="static-prefix">{{ label }}</span> -->
        <div class="selected-items">
          <!-- <p>test</p> -->
          @if (isAllSelected()) {
          <span class="selected-items-text all-selected">All</span>
          <!-- أو: All Quarters -->
          } @else {
          <span class="selected-items-text">
            @for (option of value; track $index) {
            {{ option.name }}@if (!$last) {, } } @empty { Status}
          </span>
          }
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="dropdownicon">
      <svg
        viewBox="0 0 24 24"
        width="24"
        height="24"
        focusable="false"
        aria-hidden="true"
        style="position: relative; top: -1px; left: 3px"
      >
        <path style="fill: #4f008c" d="M7 10l5 5 5-5z"></path>
      </svg>
    </ng-template>
  </p-multiSelect>
  <label
    [for]="label"
    [class.panel-shown]="isStatusDropdownShown"
    class="floating-label"
    >{{ label }}</label
  >
</p-floatLabel>
